module.exports = __webpack_public_path__ + "img/inactive-News3.647fbbab.jpg";